<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { DEPARTING_ENUM } from "../../PublicPage/Survey/tabs.config";
import VFormDemographic from "@/Shared/Survey/Departing/VFormDemographic.vue";
import VFormTravel from "@/Shared/Survey/Departing/VFormTravel.vue";
import VFormEntryPoint from "@/Shared/Survey/Departing/VFormEntryPoint.vue";
import VFormTravelArrangement from "@/Shared/Survey/Departing/VFormTravelArrangement.vue";
import VFormExpense from "@/Shared/Survey/Departing/VFormExpense.vue";
import VFormAirEntryPoint from "@/Shared/Survey/Departing/VFormAirEntryPoint.vue";
import VFormVacation from "@/Shared/Survey/Departing/VFormVacation.vue";
import VFormFeedbacks from "@/Shared/Survey/Departing/VFormFeedbacks.vue";
import { computed, ref } from "vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);

const activeComponent = computed({
    get() {
        switch (props.tab.key) {
            case DEPARTING_ENUM.FORM_1:
                return {
                    component: VFormDemographic,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_2:
                return {
                    component: VFormTravel,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_3:
                return {
                    component: VFormEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_4:
                return {
                    component: VFormAirEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_5:
                return {
                    component: VFormTravelArrangement,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_6:
                return {
                    component: VFormExpense,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_7:
                return {
                    component: VFormVacation,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
            case DEPARTING_ENUM.FORM_8:
                return {
                    component: VFormFeedbacks,
                    additional: {
                        surveyFields: props.surveyFields,
                    },
                };
        }
    },
});
</script>

<template>
    <div class="row">
        <div class="col-12">
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    :isShowSubmit="false"
                />
            </KeepAlive>
        </div>
    </div>
</template>
